import { Auth } from '@/database';

const state = {
	roles: [],
    objectTypes: [],
    accessFunctions: [],
};

const getters = {
    roles: state => state.roles,
    objectTypes: state => state.objectTypes,
    accessFunctions: state => state.accessFunctions,
};

const actions = {
	async getRoles({commit}) {
		const db = new Auth();
		const response = await db.fetch('/security/role/');
        let roles = await response.json();
		commit('setRoles', roles);
	},
    async getObjectTypes({commit}) {
        const db = new Auth();
        const response = await db.fetch('/security/object_type/');
        let objectTypes = await response.json();
        commit('setObjectTypes', objectTypes);
    },
    async getAccessFunctions({commit}) {
        const db = new Auth();
        const response = await db.fetch('/security/access_function/');
        let accessFunctions = await response.json();
        commit('setAccessFunctions', accessFunctions);
    },
};

const mutations = {
    setRoles(state, roles) {
        state.roles = roles;
    },
    setObjectTypes(state, objectTypes) {
        state.objectTypes = objectTypes;
    },
    setAccessFunctions(state, accessFunctions) {
        state.accessFunctions = accessFunctions;
    }
};

export default {
	state,
	getters,
	actions,
	mutations
};
